<div class="champion-dialog">
  <button class="close-button" (click)="onClose()" type="button" aria-label="Close">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#96080B"/>
      <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  <div class="champion-dialog-content">
    <div class="champion-dialog-header">
      <div class="champion-dialog-title-section">
        <p class="champion-dialog-title">{{ 'champion.dialog.title' | translateLang }}</p>
        <h2 class="champion-dialog-charity-name">{{ data.charityName }}</h2>
      </div>
      <p class="champion-dialog-description">
        {{ 'champion.dialog.description' | translateLang }}
      </p>
      <div class="champion-dialog-banner">
        <p class="champion-dialog-banner-text">
          {{ 'champion.dialog.banner.text' | translateLang }}
        </p>
      </div>
    </div>

    <form [formGroup]="championForm" class="champion-dialog-form">
      <div class="champion-dialog-field">
        <label class="champion-dialog-label">
          {{ 'champion.dialog.engagement.label' | translateLang }}
        </label>
        <div class="champion-dialog-date-fields">
          <select
            formControlName="engagementMonth"
            class="champion-dialog-select">
            <option *ngFor="let month of months" [value]="month.value">
              {{ 'champion.dialog.months.' + month.value | translateLang }}
            </option>
          </select>
          <select
            formControlName="engagementYear"
            class="champion-dialog-select">
            <option *ngFor="let year of years" [value]="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>

      <div class="champion-dialog-field">
        <label class="champion-dialog-label">
          {{ 'champion.dialog.testimonial.label' | translateLang }}
        </label>
        <p class="champion-dialog-helper">
          {{ 'champion.dialog.testimonial.question1' | translateLang }}<br />
          {{ 'champion.dialog.testimonial.question2' | translateLang }}<br />
          {{ 'champion.dialog.testimonial.question3' | translateLang }}<br />
          {{ 'champion.dialog.testimonial.question4' | translateLang }}
        </p>
        <textarea
          formControlName="testimonial"
          class="champion-dialog-textarea"
          [placeholder]="'champion.dialog.testimonial.placeholder' | translateLang"
          rows="4"></textarea>
      </div>

      <div class="champion-dialog-field">
        <label class="champion-dialog-label">
          {{ 'champion.dialog.duration.label' | translateLang }}
        </label>
        <select
          formControlName="duration"
          class="champion-dialog-select champion-dialog-select-full">
          <option *ngFor="let duration of durations" [value]="duration.value">
            {{ 'champion.dialog.duration.' + duration.value | translateLang }}
          </option>
        </select>
      </div>

      <div class="champion-dialog-field">
        <label class="champion-dialog-label">
          {{ 'champion.dialog.upload.label' | translateLang }}
        </label>
        <app-media-upload-control
          formControlName="mediaUpload"
          [entityUuid]="data.charityUuid"
          [secondUuid]="data.charityUuid"
          acceptedTypes=".jpg,.jpeg,.bmp,.png,.jfif,.webp"
          acceptedTypesLabel="jpg, jpeg, bmp, png, jfif, webp"
          (uploadStateChange)="onMediaUploadStateChange($event)">
        </app-media-upload-control>
      </div>
    </form>

    <div class="champion-dialog-buttons">
      <button
        type="button"
        class="champion-dialog-draft-button"
        (click)="onSaveAsDraft()"
        [disabled]="isSavingDraft || isSubmitting || isMediaUploading">
        {{ isSavingDraft ? ('champion.dialog.button.saving' | translateLang) : ('champion.dialog.button.draft' | translateLang) }}
      </button>
      <button
        type="button"
        class="champion-dialog-submit-button"
        (click)="onSubmit()"
        [disabled]="isSavingDraft || isSubmitting || isMediaUploading">
        {{ isSubmitting ? ('champion.dialog.button.submitting' | translateLang) : ('champion.dialog.button.submit' | translateLang) }}
      </button>
    </div>
  </div>
</div>
